import API from '../../../common/http/api.fetch';
// import I18N from '../../../../common/utils/util.i18n';
import {success, responseMessage} from '../../../common/utils/util.notifier';
import { GRID_FETCH, GRID_RELOAD, GRID_FILTER, GRID_SELECT_ALL } from '../../../common/grid/grid.constants';
import { TYPES } from './master-doc-list-action-type.constants';
import { IDS } from './master-doc-list-action-id.constants';
import { getDocFileNameFromPath } from "../../../common/utils/util.path";
import truncate from 'lodash/truncate';
import {formatDate} from "../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../common/utils/util.constants";

// const localizeType = (code, defaultName) => {
//     const textId = `DOCUMENT_MANAGEMENT.TYPES.${code.toUpperCase()}`;
//     const translation = I18N.translate(textId);
//     return translation === textId ? defaultName : translation
// };

export const fetchRcoDocumentAuditCycleStatusesGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-document-audit-cycle-statuses',
            method: 'GET',
            params: {
                ...filter,
                // scope_subject_types: 'cli,hof', or 'gam', or 'slo',
                due_date_to: formatDate(filter.due_date_to, DATE_FORMAT.OUTPUT),
                due_date_from: formatDate(filter.due_date_from, DATE_FORMAT.OUTPUT),
                path: undefined
            }
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.masterDocList,
                path:   filter.path,
                ...data,
                items: data.items.map( item => {
                    const reqs = (JSON.parse(item.requirements) || []).map(i => i.name);
                    const requirementsStr = reqs.length === 1 ? reqs[0]
                        : reqs.length > 2 ? reqs.map(i => i.split(' ')[0]).join(', ')
                        : reqs.join(', ');
                    const removeTimestamp = true;
                    return {
                      ...item,
                      type: item.type_name,
                      typeColumn: `${item.level} ${item.type_name}`,
                      filename: getDocFileNameFromPath(item.doc_uri, removeTimestamp) || "",
                      templateFilename: getDocFileNameFromPath(item.template),
                      requirementsRaw: item.requirements,
                      requirements: requirementsStr,
                      requirementsColumn: truncate(requirementsStr, {
                        length: 50,
                      }),
                    };
                })
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchRcoDocumentRequirementStatusesGrid = (params) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-document-requirement-statuses',
            method: 'GET',
            params
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.masterDocList,
                path:   IDS.masterDocListRequirementsGrid,
                ...data,
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const addFrameworkRequirementEvidenceGroup = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-evidence-group',
            method: 'POST',
            data
        }).then(response => {
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.masterDocList,
                path:   IDS.masterDocListGrid,
            })
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchMasterDocListDocumentDetails = (params) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/get-master-doc-list-document-details`,
            method: 'GET',
            params,
        }).then(({data}) => {
            return {
                ...data.params,
                requirementsRaw: data.params.requirements,
                requirements: undefined
            }
        }
        , error => {
            responseMessage(error);
        });
    };
}

export const editMasterDocListDocument = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/edit-master-doc-list-document',
            method: 'POST',
            data,
        }).then(response => {
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.masterDocList,
                path:   IDS.masterDocListGrid,
            })
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        }, error => {
            responseMessage(error);
        });
    };
}

export const invalidateEvidenceGroup = (ard_id, path) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/invalidate-evidence-group',
            method: 'POST',
            data: { ard_id }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_DELETED');
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.masterDocList,
                path,
            });
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchSiteLocationDetails = (siteLocationUuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/sitelocation/${siteLocationUuid}`,
            method: 'GET',
            params: {}
        }).then(response => {
            return response.data[0][0];
        })
    }
}